export default {
    props: {
        currencies: {
            type: Object,
            required: true
        },
    },
    provide() {
        return {
            currencies: {
                list: this.currencies.list,
                defaultCurrency: this.currencies.default
            }
        };
    }
};
